import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
import { BaseFormService } from 'app/services/BaseFormService';
import { UtilityService } from 'app/services/utility.service';

@Injectable({
	providedIn: 'root',
})
export class ThirdPartyIntegrationFormService extends BaseFormService {
	constructor(httpClient: HttpClient, utilityService: UtilityService) {
		super(
			`${environment.apiUrl}cashiering/clients/$$clientId$$/forms/third-party-integration-form`,
			httpClient,
			utilityService
		);
	}
	getForm(clientId: string, id: string): Observable<any> {
		return this.httpClient.get<any>(`${this.getUrl(clientId)}/${id}`).pipe();
	}

	submitForApproval(clientId: string, id: any, userId: string): Observable<any> {
		return this.httpClient
			.post<any>(`${this.getUrl(clientId)}/${id}/approval`, {
				userId,
			})
			.pipe();
	}
	checkExistingForm(
		clientId: string,
		provider: any,
		formId: any,
		type: any,
		projectType: any,
		transactionTypes: any,
		startDate: any,
		endDate: any
	): Observable<any> {
		const url = `${this.getUrl(clientId)}/check-existing-form`;
		const params = {
			provider,
			formId,
			type,
			projectType,
			transactionTypes,
			startDate,
			endDate,
		};
		return this.httpClient.get<any>(url, { params }).pipe();
	}
	getThirdPartyIntegrationFormReport(clientId: string, request: any): Observable<any> {
		return this.httpClient.post<any[]>(`${this.getUrl(clientId)}/report`, request).pipe();
	}
}
